import { injectable } from 'inversify';
import { IBrowserService } from './interfaces';
import BrowserInfoModel from '../common/model/BrowserInfoModel';

@injectable()
class BrowserService implements IBrowserService {
    model: BrowserInfoModel;

    constructor() {
      this.model = new BrowserInfoModel();
    }
    
   getBrowserInfo = (): BrowserInfoModel => {
        const nAgt = navigator.userAgent;
        let browserName = navigator.appName;
        let fullVersion = `${parseFloat(navigator.appVersion)}`;
        const majorVersion = parseInt(navigator.appVersion, 10);
        let nameOffset: any; let verOffset: any;
        if ((nAgt.indexOf('Chrome')) !== -1) {
            verOffset = nAgt.indexOf('Chrome');
            browserName = 'Chrome';
            fullVersion = nAgt.substring(verOffset + 7);
        } else if ((nAgt.indexOf('Firefox')) !== -1) {
            verOffset = nAgt.indexOf('Firefox');
            browserName = 'Firefox';
            fullVersion = nAgt.substring(verOffset + 8);
        } else if ((nAgt.indexOf('Opera')) !== -1) {
            verOffset = nAgt.indexOf('Opera');
            browserName = 'Opera';
            fullVersion = nAgt.substring(verOffset + 6);
        } else if ((nAgt.indexOf('MSIE')) !== -1) {
            verOffset = nAgt.indexOf('MSIE');
            browserName = 'MSIE';
            fullVersion = nAgt.substring(verOffset + 5);
        } else if ((nAgt.indexOf('Safari')) !== -1) {
            verOffset = nAgt.indexOf('Safari');
            browserName = 'Safari';
            fullVersion = nAgt.substring(verOffset + 8);
        } else if ((nAgt.lastIndexOf(' ') + 1)
        < (nAgt.lastIndexOf('/'))) {
            nameOffset = nAgt.lastIndexOf(' ');
            verOffset = nAgt.lastIndexOf('/');
            browserName = nAgt.substring(nameOffset, verOffset);
            fullVersion = nAgt.substring(verOffset + 1);
            if (browserName.toLowerCase() === browserName.toUpperCase()) {
                browserName = navigator.appName;
            }
        }
        this.model.OperatingSystem = 'Unknown OS';
        if (navigator.appVersion.indexOf('Win') !== -1) { this.model.OperatingSystem = 'Windows'; }
        if (navigator.appVersion.indexOf('Mac') !== -1) { this.model.OperatingSystem = 'MacOS'; }
        if (navigator.appVersion.indexOf('X11') !== -1) { this.model.OperatingSystem = 'UNIX'; }
        if (navigator.appVersion.indexOf('Linux') !== -1) { this.model.OperatingSystem = 'Linux'; }
        this.model.BrowserName = browserName;
        this.model.BrowserFullVersion = fullVersion;
        this.model.BrowserMajorVersion = majorVersion;
        this.model.NavigatorAppName = navigator.appName;
        this.model.NavigatorUserAgent = navigator.userAgent;
        return this.model;
    }
}

export default BrowserService;